import type { SiteId, Slot } from "./types";
import worldAtlas from "world-atlas/countries-110m.json" with { type: "json" };

const shopNames = [
  "Orange Kiosk",
  "Unit 02",
  "Food Court A",
  "Escalator Left",
  "Unit 05",
  "Tiny Corner Shop",
  "Atrium Prime",
  "Unit 08",
  "Food Court B",
  "Unit 10",
  "Fountain Facing",
  "Unit 12",
  "Cinema Lobby",
  "Unit 14",
  "Unit 15",
  "Loading Bay Chic",
  "Unit 17",
  "Last Shop Standing",
];

const homeLots = [
  ["apricot-mews-01", "01 Apricot Mews"],
  ["satellite-close-07", "07 Satellite Close"],
  ["cache-lane-13", "13 Cache Lane"],
  ["browser-terrace-22", "22 Browser Terrace"],
  ["loading-lane-42", "42 Loading Lane"],
  ["cookie-crescent-64", "64 Cookie Crescent"],
  ["hyperlink-heights-88", "88 Hyperlink Heights"],
  ["not-found-road-404", "404 Not Found Road"],
];

function emptySlots(labels: string[], prefix: string): Slot[] {
  return labels.map((label, index) => ({
    id: `${prefix}-${String(index + 1).padStart(2, "0")}`,
    label,
    entries: [],
  }));
}

function landSlots(): Slot[] {
  const rows = ["A", "B", "C", "D", "E"];
  return rows.flatMap((row) =>
    Array.from({ length: 6 }, (_, column) => ({
      id: `parcel-${row}${column + 1}`,
      label: `Parcel ${row}${column + 1}`,
      entries: [],
    })),
  );
}

function slug(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function getCatalog(site: SiteId): Slot[] {
  return (
    site === "earth"
      ? worldAtlas.objects.countries.geometries.map((country) => ({
          id: `country-${country.id ?? slug(country.properties.name)}`,
          label: country.properties.name,
          entries: [],
        }))
      : site === "shop"
      ? emptySlots(shopNames, "shop")
      : site === "homes"
        ? homeLots.map(([id, label]) => ({ id, label, entries: [] }))
        : site === "land"
          ? landSlots()
          : []
  );
}

export function getCatalogSlot(site: SiteId, slotId: string): Slot | undefined {
  return getCatalog(site).find((slot) => slot.id === slotId);
}

export function mergeCatalog(site: SiteId, claimed: Slot[]): Slot[] {
  const catalog = getCatalog(site);

  const claimedMap = new Map(claimed.map((slot) => [slot.id, slot]));
  // Inventory is finite and server-authoritative. Unknown legacy/corrupt slots
  // must never become purchasable or visible merely because they reached disk.
  return catalog.map((slot) => claimedMap.get(slot.id) ?? slot);
}
